@import '~style-sheet-helpers/core.less';
@import (reference) '../../constants/spacing.module.less';
@import '../../app-brand/entities/entity-layer.module.less';

.banner {
  border: solid 1px var(--purple-8D30F7);
  border-radius: @space-8;
  background: var(--purple-F6F2FF);

  &.sparkly {
    border: 1px solid transparent;
    border-image-slice: 1;
    background-image:
      linear-gradient(to right, var(--blue-DBECFE), var(--purple-EEE8FF), var(--red-F8DEDE)),
      linear-gradient(to right, var(--blue-93CCFD), var(--purple-B085FF), var(--red-F1C1C1));
    background-origin: border-box;
    background-clip: content-box, border-box;

    .icon {
      > path {
        fill: var(--purple-6964ff);
      }
    }
  }
}

.wrapper {
  padding: @space-16;
  flex-wrap: nowrap;
  gap: @space-12;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.icon {
  height: @space-16;
  min-height: @space-16;
  width: @space-16;
  min-width: @space-16;
  margin: @space-4 0;

  > path {
    fill: var(--purple-8D30F7);
  }
}

.header {
  gap: @space-12;
  flex-wrap: nowrap;
  align-items: center;
}

.twoButtons {
  align-items: center;
  margin-top: @space-12;
  gap: @space-12;
}

.close-button {
  align-self: flex-start;
  color: var(--gray-637381);
}
